export default {
  nav: {
    home: '首页',
    categories: '分类',
    tags: '标签',
    about: '关于',
    search: '搜索文章...'
  },
  footer: {
    friendLinks: '友情链接：'
  },
  home: {
    subtitle: '记录技术与生活'
  },
  article: {
    all: '全部',
    tag: '标签: {0}',
    noArticles: '暂无文章',
    views: '{0} 次浏览',
    prev: '上一篇',
    next: '下一篇',
    notFound: '文章不存在',
    adminOnly: '该内容仅管理员可见，请使用管理员账号登录',
    commentTitle: '评论 ({0})'
  },
  comment: {
    nickname: '昵称',
    email: '邮箱（选填）',
    placeholder: '写下你的评论...',
    submit: '发表评论',
    cancel: '取消',
    nicknameRequired: '请输入昵称',
    contentRequired: '请输入评论内容',
    submitSuccess: '评论成功，等待审核',
    empty: '暂无评论，快来抢沙发吧！',
    anonymous: '匿名',
    reply: '回复'
  },
  sidebar: {
    categories: '分类',
    tagCloud: '标签云',
    latestArticles: '最新文章',
    noCategories: '暂无分类',
    noTags: '暂无标签',
    noArticles: '暂无文章'
  },
  search: {
    title: '搜索结果',
    placeholder: '搜索文章...',
    button: '搜索',
    resultSummary: '搜索 "<strong>{0}</strong>" 的结果，共 {1} 条',
    notFound: '未找到相关文章',
    enterKeyword: '请输入关键词进行搜索'
  },
  category: {
    title: '分类归档',
    articleCount: '{0} 篇文章',
    empty: '暂无分类'
  },
  pages: {
    title: '页面',
    empty: '暂无页面',
    notFound: '页面不存在',
    adminOnly: '该内容仅管理员可见，请使用管理员账号登录',
    uploadTime: '上传于 {0}'
  },
  tag: {
    title: '标签归档',
    empty: '暂无标签'
  },
  about: {
    bio: '一个记录技术与生活的个人博客',
    aboutSite: '关于本站',
    description: '欢迎来到 wuBlog！这是一个基于 Vue + Spring Boot 搭建的个人博客系统，用于记录编程学习过程中的心得体会、技术分享以及生活随笔。',
    techStack: '技术栈',
    contact: '联系方式',
    email: '邮箱: {0}',
    github: 'GitHub: {0}'
  },
  langSwitch: 'EN'
}
